import { render } from "./DualloLoaderWrapper.vue?vue&type=template&id=2d85f05a&scoped=true"
import script from "./DualloLoaderWrapper.vue?vue&type=script&lang=js"
export * from "./DualloLoaderWrapper.vue?vue&type=script&lang=js"

import "./DualloLoaderWrapper.vue?vue&type=style&index=0&id=2d85f05a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d85f05a"]])

export default __exports__